<template>
  <div id="our-values" class="section" :style="`background-color: var(--${vars.backgroundColor}) !important;`">
    <div class="container-default w-container">
      <div
        data-w-id="cb3b4fce-6b95-82f1-c182-6546198a6449"
        class="text-center mg-bottom-40px tw-mx-auto tw-max-w-[850px]"
        style="
          transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg)
            skew(0deg, 0deg);
          transform-style: preserve-3d;
          opacity: 1;
        "
      >
        <h2
          v-if="vars.titleText"
          class="display-2 color-neutral-100 mg-bottom-8px"
          :style="`color: var(--${vars.textColor}) !important;`"
        >
          {{ vars.titleText }}
        </h2>
        <p
          v-if="vars.descriptionText"
          class="color-neutral-400 mg-bottom-0 center-text"
          :style="`color: var(--${vars.textColor}) !important;`"
        >
          {{ vars.descriptionText }}
        </p>
      </div>
      <div
        class="table-container tw-w-full tw-overflow-auto tw-rounded-2xl tw-p-10"
        :style="`background-color: var(--${vars.cardBackgroundColor}) !important; color: var(--${vars.cardTextColor}) !important;`"
      >
      <table class="comparison-table tw-w-full tw-overflow-auto" style="border-collapse: collapse">
          <thead>
            <tr>
              <th class="display-3 tw-w-1/2 tw-pr-10" :style="`color: var(--${vars.cardTextColor}) !important;`">
                {{ vars.column1TitleText }}
              </th>
              <th class="display-3 tw-w-1/4 tw-pr-10" :style="`color: var(--${vars.cardTextColor}) !important;`">
                {{ vars.column2TitleText }}
              </th>
              <th
                class="display-3 tw-w-1/4 tw-whitespace-nowrap"
                :style="`color: var(--${vars.cardTextColor}) !important;`"
              >
                {{ vars.column3TitleText }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td class="tw-whitespace-nowrap tw-py-4 tw-pr-12 !tw-text-xl">
                {{ row.title }}
              </td>
              <td class="tw-py-4 tw-pr-12">
                <span v-if="row.first_feature"
                  ><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 48 48">
                    <path fill="#43A047" d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"></path></svg
                ></span>
                <span v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="36"
                    height="36"
                    viewBox="0,0,256,256"
                    style="fill: #fa5252"
                  >
                    <g
                      fill="#fa5252"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <g transform="scale(5.12,5.12)">
                        <path
                          d="M9.15625,6.3125l-2.84375,2.84375l15.84375,15.84375l-15.9375,15.96875l2.8125,2.8125l15.96875,-15.9375l15.9375,15.9375l2.84375,-2.84375l-15.9375,-15.9375l15.84375,-15.84375l-2.84375,-2.84375l-15.84375,15.84375z"
                        ></path>
                      </g>
                    </g></svg
                ></span>
              </td>
              <td class="tw-py-4">
                <span v-if="row.second_feature"
                  ><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 48 48">
                    <path fill="#43A047" d="M40.6 12.1L17 35.7 7.4 26.1 4.6 29 17 41.3 43.4 14.9z"></path></svg
                ></span>
                <span v-else
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="36"
                    height="36"
                    viewBox="0,0,256,256"
                    style="fill: #fa5252"
                  >
                    <g
                      fill="#fa5252"
                      fill-rule="nonzero"
                      stroke="none"
                      stroke-width="1"
                      stroke-linecap="butt"
                      stroke-linejoin="miter"
                      stroke-miterlimit="10"
                      stroke-dasharray=""
                      stroke-dashoffset="0"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode: normal"
                    >
                      <g transform="scale(5.12,5.12)">
                        <path
                          d="M9.15625,6.3125l-2.84375,2.84375l15.84375,15.84375l-15.9375,15.96875l2.8125,2.8125l15.96875,-15.9375l15.9375,15.9375l2.84375,-2.84375l-15.9375,-15.9375l15.84375,-15.84375l-2.84375,-2.84375l-15.84375,15.84375z"
                        ></path>
                      </g>
                    </g></svg
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'CoreValues',

  mixins: [ComponentMixin],

  computed: {
    rows() {
      return this.groupedVariables.rows;
    },

    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
